import React from 'react';
import { string, object } from 'prop-types';
function CheckMarkIcon({
  className,
  style
}) {
  return /*#__PURE__*/React.createElement("svg", {
    className: className,
    style: style,
    viewBox: "0 0 15 13"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M1 6l4.615 5L14 1"
  }));
}
CheckMarkIcon.defaultProps = {
  className: undefined,
  style: undefined
};
CheckMarkIcon.propTypes = {
  className: string,
  // eslint-disable-next-line react/forbid-prop-types
  style: object
};
export default CheckMarkIcon;